import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";

const QUESTIONNAIRE_MAP = {
    ONE_INTAKE_FIELDS :
        [
            {
                fieldName: "u_autodesk_business_contact.user_name",
                questionText: "Requested for"
            },
            {
                fieldName: "u_watch_list",
                questionText: "Watchers"
            },
            {
                fieldName: "u_detailed_description_of_product_or_service",
                questionText: "1. Detailed description of product or service the supplier will be providing"
            },
            {
                fieldName: "u_product_name",
                questionText: "2. Product name"
            },
            {
                fieldName: "u_requested_start_date",
                questionText: "3. Requested services start date"
            },
            {
                fieldName: "u_vendor_service_category",
                questionText: "4. Procurement category"
            },
            {
                fieldName: "u_business_justification_to_engage_with_supplier",
                questionText: "5. Business justification to engage with supplier"
            },
            {
                fieldName: "u_supp_employee_count",
                questionText: "6. Does the supplier have fewer than five (5), full time, regular employees?"
            },
            {
                fieldName: "u_which_service_is_your_supplier_providing",
                questionText: "6 a. Which service is your supplier providing?"
            },
            {
                fieldName: "u_where_is_your_supplier_located",
                questionText: "6 b. Where is your Supplier located?"
            },
            {
                fieldName: "u_autodesk_company_buying_these_services",
                questionText: "7. What Autodesk company is buying these services / this product?"
            },
            {
                fieldName: "u_do_you_need_help_finding_a_supplier",
                questionText: "8. Have you selected a supplier?"
            },
            {
                fieldName: "u_supplier_name",
                questionText: "8 a. Supplier name"
            },
            {
                fieldName: "u_please_provide_a_link_to_supplier_website",
                questionText: "8 b. URL for supplier’s website"
            },
            {
                fieldName: "u_supplier_contact_name",
                questionText: "8 c. Name of your contact at supplier"
            },
            {
                fieldName: "u_supplier_contact_role",
                questionText: "8 d. Supplier contact role"
            },
            {
                fieldName: "u_supplier_contact_email",
                questionText: "8 e. Supplier contact email"
            },
            {
                fieldName: "u_country",
                questionText: "8 f. Supplier country"
            },
            {
                fieldName: "u_diverse_supplier_considered",
                questionText: "8 g. Have you considered a diverse supplier?"
            },
            {
                fieldName: "u_buying_technology_through_a_reseller",
                questionText: "9. Are you buying this technology through a reseller?"
            },
            {
                fieldName: "u_technology_reseller",
                questionText: "9 a. Reseller name"
            },
            {
                fieldName: "u_approximate_spend",
                questionText: "10. Approximate cost"
            },
            {
                fieldName: "u_planning_with_corporate_card",
                questionText: "10 a. Are you planning on paying for this with a corporate card?"
            },
            {
                fieldName: "u_recommended_by_government_official",
                questionText: "11. Was this supplier suggested or recommended by a government official, or will this supplier engagement involve any of the following: (a) lobbying or of consulting on government affairs; (b) interacting with government officials on Autodesk’s behalf; or (c) services involving a government official?"
            },
            {
                fieldName: "u_interacting_autodesk_customers_on_our_behalf",
                questionText: "12. Will this supplier engagement involve them interacting with Autodesk customers on our behalf?"
            },
            {
                fieldName: "u_does_anyone_have_relationship",
                questionText: "13. Do you or, to your knowledge, does anyone else at Autodesk have a relationship with the supplier or an employee of the supplier that must be disclosed and vetted under our Conflicts of Interest Policy?"
            },
            {
                fieldName: "u_will_the_supplier_service_be_integrated_with_any_autodesk_product_or_system",
                questionText: `14.Will the supplier’s service or product (i.e., third-party component) be integrated into or released with any Autodesk product, service, or platform? This could include a supplier that is licensing a product or providing a SaaS or PaaS service that will be integrated in an Autodesk product.`
            },
            {
                fieldName: "u_will_supplier_be_developing_autodesk_product_code",
                questionText: `14 a. Will the supplier be engaged to provide professional services for the purpose of developing Autodesk product code?`
            },
            {
                fieldName: "u_will_the_supplier_process_personal_data",
                questionText: "15. Will the supplier’s engagement involve the processing of Autodesk personal data?"
            },
            {
                fieldName: "u_autodesk_customer_data",
                questionText: "15 a. What type of personal data will the supplier be processing as a part of this engagement?"
            },
            {
                fieldName: "u_are_you_acquiring_or_licensing_any_third_party_techonology",
                questionText: "16. Are you acquiring or licensing any third-party technology, service, or software?"
            },
            {
                fieldName: "u_will_the_supplier_service_be_integrating_with_an_autodesk_system",
                questionText: "16 a. Will the supplier’s service, application, or product be accessing any Autodesk network or system in any way?"
            },
            {
                fieldName: "u_will_the_supplier_be_installing_any_code_cookie_or_tag_on_an_autodesk_website",
                questionText: "16 b. Will the supplier be installing any code, cookie, or tag on an Autodesk website?"
            },
            {
                fieldName: "u_customer_intellectual_property",
                questionText: "16 c. Will the supplier have access to or process any customer intellectual property?"
            },
            {
                fieldName: "u_software_licenses_installed_on_adsk_machine",
                questionText: "16 d. If purchasing software, are the licenses installed on an Autodesk device or within the Autodesk network?"
            },
             {
                fieldName:"u_engagement_is_pilot_or_poc",
                questionText:"16 e. Is this engagement a pilot or proof of concept?"
            },
            {
                fieldName: "u_artificial_intelligence_or_machine_learning",
                questionText: "16 f. Will the supplier service or product involve any artificial intelligence or machine learning?"
            },
            {
                fieldName: "u_does_this_engagement_involve_generative_ai",
                questionText: "16 g. Does this engagement involve Generative AI?"
            },
            {
                fieldName:"u_generativeai_attestation",
                questionText:"Generative AI Attestation submitted? "
            },
            {
                fieldName: "u_describe_the_purchase_type",
                questionText: "17. Please describe the type of purchase"
            },
            {
                fieldName: "u_is_there_a_current_master_agreement_in_place_with_this_supplier",
                questionText: "18. Is there a current master agreement in place with this supplier?"
            },
            {
                fieldName: "u_will_the_services_be_delivered_within_a_time_period_of_no_more_than_one_year",
                questionText: "19. Will the services be completed within one year?"
            },
            {
                fieldName: "u_will_the_supplier_provide_tax_audit_or_legal_services",
                questionText: "20. Will the supplier provide tax, audit, or legal services?"
            }
        ],
    EXCEPTION_SUBMISSION_REQUEST_FIELDS: [
        {
            fieldName: "u_autodesk_business_contact.user_name",
            questionText: "Requested for"
        },
        {
            fieldName: "u_watch_list",
            questionText: "Watchers"
        },
        {
            fieldName: "u_this_request_is_for_a",
            questionText: "1. Request type"
        },
        {
            fieldName: "u_steps_completed_for_sponsorship",
            questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.SPONSORSHIP_TEXT
        },
        {
            fieldName: "u_steps_completed_for_corporate_donation",
            questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.CORPORATE_DONATION_TEXT
        },
        {
            fieldName: "u_approval_and_agreement_available_for_speaker",
            questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.SPEAKER_TEXT
        },
        {
            fieldName: "u_exception_request_description",
            questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.OTHER_TEXT
        },
        {
            fieldName: "u_necessary_steps_and_supporting_documentation_completed_for_purchase",
            questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.GENERIC_CHECKBOX_TEXT
        },
        {
            fieldName: "u_detailed_description_of_product_or_service",
            questionText: "2. Brief description"
        },
        {
            fieldName: "u_autodesk_company_buying_these_services",
            questionText: "3. What Autodesk company is buying these services / this product?"
        },
        {
            fieldName: "u_recommended_by_government_official",
            questionText: "4. Was this supplier suggested or recommended by a government official, or will this supplier engagement involve any of the following: (a) lobbying or of consulting on government affairs; (b) interacting with government officials on Autodesk’s behalf; or (c) services involving a government official?"
        },
        {
            fieldName: "u_interacting_autodesk_customers_on_our_behalf",
            questionText: "5. Will this supplier engagement involve them interacting with Autodesk customers on our behalf?"
        },
        {
            fieldName: "u_does_anyone_have_relationship",
            questionText: "6. Do you or, to your knowledge, does anyone else at Autodesk have a relationship with the supplier or an employee of the supplier that must be disclosed and vetted under our Conflicts of Interest Policy?"
        },
        {
            fieldName: "u_approximate_spend",
            questionText: "7. Approximate cost"
        },
        {
            fieldName: "u_supplier_name",
            questionText: "8. Supplier name"
        },
        {
            fieldName: "u_please_provide_a_link_to_supplier_website",
            questionText: "8 a. URL for supplier’s website"
        },
        {
            fieldName: "u_supplier_contact_name",
            questionText: "8 b. Name of your contact at supplier"
        },
        {
            fieldName: "u_supplier_contact_role",
            questionText: "8 c. Supplier contact role"
        },
        {
            fieldName: "u_supplier_contact_email",
            questionText: "8 d. Supplier contact email"
        },
        {
            fieldName: "u_country",
            questionText: "8 e. Supplier country"
        },
        {
            fieldName: "u_exception_corp_card_payment",
            questionText: "9. Corporate Card Type"
        }
    ]

}


export default QUESTIONNAIRE_MAP;